export default "__VITE_PUBLIC_ASSET__d5760f2e__"